import {Box} from 'src/design/atoms/Box';
import React from 'react';
import {OptionButtonGroup} from 'src/design/atoms/OptionButtonGroup';
import type {OptionButtonGroupOption} from 'src/design/atoms/OptionButtonGroup';

const resultOptions: OptionButtonGroupOption[] = [
  {value: 'pass', label: 'Pass', color: 'green'},
  {value: 'fail', label: 'Fail', color: 'red'},
  {value: 'no-access', label: 'No Access', color: 'blue'},
];

/**
 * Non-editable preview of the inspection RESULT control an inspector fills
 * in first — Pass/Fail/No Access. Capture (selection persistence) is out of
 * scope for the builder preview; this shows layout only.
 */
export const ResultPreviewLeadIn: React.FC = () => (
  <Box mb="md">
    <OptionButtonGroup
      label="Result"
      options={resultOptions}
      value={null}
      onChange={() => {}}
      readOnly
    />
  </Box>
);
